// The "Refer and earn" control in the brand bar (components/Layout.js): who sees it, and where it
// goes. Clients only; a restricted account is not offered the program. Admin, staff and editors
// have no code to share. Pure, so the rule has a node test.
export const REFER_LABEL = 'Refer and earn';
export const REFER_TARGET = '/gem-bag#referral';

export function showReferButton(user) {
  return Boolean(user) && user.role === 'client' && !user.restricted;
}
